(function(){
  // Region grouping order. "region" values in the data are Central/East/North-East/North/West.
  var REGION_ORDER=['Central','East','North-East','North','West'];
  var TNAME={'3':'3-Room','4':'4-Room','5':'5-Room','E':'Exec'};

  function init(root){
    if(!root||root.dataset.blkInit)return; root.dataset.blkInit='1';
    var DATA; try{DATA=JSON.parse(root.querySelector('[data-blk-data]').textContent);}catch(e){return;}
    var rowsWrap=root.querySelector('[data-blk-rows]');
    var type='All';

    // Mirror scripts/hdb_updates/post_hdb_product.py::slugify + block_handle so a
    // card resolves to its own resale product page: /products/{block}-{street}-hdb-resale.
    // An explicit b.url or b.handle in the data wins over the computed guess.
    function slug(s){return String(s||'').replace(/[^A-Za-z0-9]+/g,'-').replace(/^-+|-+$/g,'').toLowerCase()||'x';}
    function blockUrl(b){
      if(b.url)return b.url;
      if(b.handle)return '/products/'+b.handle;
      var blk=String(b.blk||'').replace(/^\s*blk\s*/i,''); // data stores "Blk 690"; handle wants "690"
      var street=b.addr||'';
      if(!blk||!street)return '';
      return '/products/'+slug(blk)+'-'+slug(street)+'-hdb-resale';
    }

    function cardHtml(b){
      var showType = (type!=='All'&&b.psf[type])?type:b.types[0];
      var psf=b.psf[showType]||b.psf[b.types[0]];
      var href=blockUrl(b);
      var otag=href?'<a class="bcard" href="'+href+'">':'<div class="bcard">';
      var ctag=href?'</a>':'</div>';
      var bimg=b.img?' style="background-image:url('+b.img+');background-size:cover;background-position:center top;"':'';
      return otag+'<div class="bimg"'+bimg+'>'+(b.tag?'<span class="verd '+(b.tag.indexOf("premium")>-1?"hot":"value")+'">'+b.tag+'</span>':'')+'</div><div class="bbody"><div class="bblk">'+b.blk+'</div><div class="baddr">'+b.addr+' · '+b.town+'</div><div class="bstats"><div><div class="sk">Types</div><div class="sv">'+b.types.map(function(t){return TNAME[t];}).join(' · ')+'</div></div><div><div class="sk">Median PSF</div><div class="sv">$'+psf+'</div></div></div></div>'+ctag;
    }

    function render(){
      var html='';
      REGION_ORDER.forEach(function(rg){
        var rows=DATA.filter(function(b){
          if(b.region!==rg)return false;
          return type==='All'||b.types.indexOf(type)>-1;
        });
        if(!rows.length)return;
        var count=rows.length+(rows.length===1?' block':' blocks');
        html+='<div class="blk-region-row">'
          +'<div class="blk-rr-head"><div class="blk-rr-label"><span class="blk-rr-name">'+rg+'</span><span class="blk-rr-count">'+count+'</span></div>'
          +'<div class="blk-rr-nav"><button class="blk-rr-nav-btn" data-dir="prev" aria-label="Scroll left">&#8249;</button><button class="blk-rr-nav-btn" data-dir="next" aria-label="Scroll right">&#8250;</button></div></div>'
          +'<div class="blk-carousel"><div class="blk-carousel-track">'+rows.map(cardHtml).join('')+'</div></div>'
          +'</div>';
      });
      rowsWrap.innerHTML=html||'<div class="blk-empty">No blocks match that filter.</div>';
      wireCarousels();
    }

    // Mouse-drag + arrow nav, same mechanics as assets/newlaunch-dashboard.js. Touch
    // scroll is native (overflow-x:auto). innerHTML is replaced on each render so old
    // track nodes (and their listeners) are discarded — no listener build-up.
    function wireCarousels(){
      [].forEach.call(rowsWrap.querySelectorAll('.blk-carousel-track'),function(track){
        var isDown=false,startX=0,sl=0;
        track.addEventListener('mousedown',function(e){isDown=true;track.classList.add('is-dragging');startX=e.pageX-track.offsetLeft;sl=track.scrollLeft;e.preventDefault();});
        track.addEventListener('mouseleave',function(){isDown=false;track.classList.remove('is-dragging');});
        track.addEventListener('mouseup',function(){isDown=false;track.classList.remove('is-dragging');});
        track.addEventListener('mousemove',function(e){if(!isDown)return;e.preventDefault();var x=e.pageX-track.offsetLeft;track.scrollLeft=sl-(x-startX)*1.5;});
        track.addEventListener('click',function(e){if(track.classList.contains('is-dragging'))e.preventDefault();},{capture:true});
      });
      [].forEach.call(rowsWrap.querySelectorAll('.blk-rr-nav-btn'),function(btn){
        btn.addEventListener('click',function(){
          var row=btn.closest('.blk-region-row'); if(!row)return;
          var track=row.querySelector('.blk-carousel-track'); if(!track)return;
          var dir=btn.dataset.dir==='prev'?-1:1;
          var card=track.querySelector('.bcard');
          var cw=card?card.offsetWidth+14:262;
          track.scrollBy({left:dir*cw*2,behavior:'smooth'});
        });
      });
    }

    var tSel=root.querySelector('[data-blk-type]');
    if(tSel)tSel.addEventListener('change',function(){type=this.value;render();});
    render();
  }

  function all(){[].forEach.call(document.querySelectorAll('[data-hdb-blocks]'),init);}
  if(document.readyState!=='loading')all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){var el=e.target.querySelector('[data-hdb-blocks]'); if(el){el.dataset.blkInit=''; init(el);}});
})();
